import React, { useState } from 'react'
import WebFeeManagement from '../components/WebFeeManagement/WebFeeManagement'

const WebFeeManagementPage = () => {
  return (
    <>
      <WebFeeManagement />
    </>
  )
}

export default WebFeeManagementPage
